import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { createEntityProfile, entityProfile, updateProfileSection } from './types';

import {
  requestCreateEntityProfileSuccess,
  requestCreateEntityProfileFailure,
  requestEntityProfileSuccess,
  requestEntityProfileFailure,
  requestUpdateProfileSectionSuccess,
  requestUpdateProfileSectionFailure,
} from './reducer';
import { mapProfileToEditForm } from 'modules/MonitorWizzard/utils/newProfileMap';

const logger = new Logger('Saga:FundingSearchProfile');

export function* requestCreateEntityProfileSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.create_entity_profile', { entityId: action.entityId }),
    );

    yield put(requestCreateEntityProfileSuccess(action.entityId, response.data));
    yield put(requestEntityProfileSuccess(action.entityId, response.data));
  } catch (error) {
    logger.error('Failed to create entity profile with the following error', error);
    yield put(requestCreateEntityProfileFailure(action.entityId, error));
    yield put(requestEntityProfileFailure(action.entityId, error));
  }
}

export function* requestEntityProfileSaga(action) {
  const authApiService = yield getContext('authApiService');

  try {
    const profileData = yield call(
      authApiService.get,
      `${window._env_.PLATFORM_API_DOMAIN}/v1/profiles/entity/${action.entityId}`,
    );

    const { uuid } = profileData.data;

    const sectionData = yield call(
      authApiService.get,
      `${window._env_.PLATFORM_API_DOMAIN}/v1/profiles/${uuid}/company-details`,
    );

    const newProfileCompanyDetails = sectionData.data;

    const newData = mapProfileToEditForm('basic-company-details', uuid, newProfileCompanyDetails);

    yield put(requestEntityProfileSuccess(action.entityId, newData));
    action.promise && action.promise.resolve();
  } catch (error) {
    logger.error('Failed to request entity profile with the following error', error);
    yield put(requestEntityProfileFailure(action.entityId, error));
    action.promise && action.promise.reject();
  }
}

export function* requestUpdateProfileSectionSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.put,
      routerService.generate('api.update_entity_profile_section', {
        entityId: action.entityId,
        sectionId: action.sectionId,
      }),
      action.payload,
    );

    yield put(requestUpdateProfileSectionSuccess(action.entityId, action.sectionId, response.data));
    action.promise && action.promise.resolve();
  } catch (error) {
    logger.error('Failed to update entity profile section with the following error', error);
    yield put(requestUpdateProfileSectionFailure(action.entityId, action.sectionId, error));
    action.promise && action.promise.reject();
  }
}

export default function* fundingSearchSaga() {
  return yield all([
    takeLatest(createEntityProfile.request, requestCreateEntityProfileSaga),
    takeLatest(entityProfile.request, requestEntityProfileSaga),
    takeLatest(updateProfileSection.request, requestUpdateProfileSectionSaga),
  ]);
}
